import type { SxSViewState } from "owa-sxsdata";
import { getRecentFilesStore } from "../store/store";

export default function getSxSViewState(): SxSViewState {
    return getRecentFilesStore().sxsState.viewState;
}
